import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { FilePanelProps } from "@/types";
import { projectSaveStore } from "@/hooks";
import { FlexBox, TextInput, Icon, SelectInput } from "@/components/common";


/**
 * Provides inputs for the file panel name.
 */
const __default__ = {
  name: "UploadPanelName",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    panel: {},
    index: {},
    hideUploadType: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const artifactTypes = computed(() => projectSaveStore.artifactTypes);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.panel.variant === 'trace')
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          "full-width": "",
          align: "center",
          y: "2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectInput), {
              modelValue: props.panel.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.panel.type) = $event)),
              label: "Source Type",
              options: artifactTypes.value,
              hint: "Required",
              class: "full-width",
              "data-cy": "input-source-type"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_unref(Icon), {
              class: "q-mx-sm",
              variant: "trace",
              size: "sm"
            }),
            _createVNode(_unref(SelectInput), {
              modelValue: props.panel.toType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.panel.toType) = $event)),
              label: "Target Type",
              options: artifactTypes.value,
              hint: "Required",
              class: "full-width",
              "data-cy": "input-target-type"
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (props.panel.variant === 'artifact')
      ? (_openBlock(), _createBlock(_unref(TextInput), {
          key: 1,
          modelValue: props.panel.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.panel.type) = $event)),
          label: "Artifact Type",
          hint: "Required",
          "data-cy": "input-artifact-type"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})